// extracted by mini-css-extract-plugin
export var $animation_name = "SimpleHeader-module--$animation_name--8c1f5";
export var Inner = "SimpleHeader-module--Inner--c1514";
export var Wrapper = "SimpleHeader-module--Wrapper--7811e";
export var Wrapper___tall = "SimpleHeader-module--Wrapper___tall--90c09";